const actions = {
  SEARCH_MEMBERSHIP_LEVELS: 'SEARCH_MEMBERSHIP_LEVELS',
  SEARCH_MEMBERSHIP_LEVELS_ENDED: 'SEARCH_MEMBERSHIP_LEVELS_ENDED',
  SEARCH_MEMBERSHIP_LEVEL_RULES: 'SEARCH_MEMBERSHIP_LEVEL_RULES',
  SEARCH_MEMBERSHIP_LEVEL_RULES_ENDED: 'SEARCH_MEMBERSHIP_LEVEL_RULES_ENDED',
  SEARCH_MEMBERSHIP_LEVEL_TRANSITION_RECORDS: 'SEARCH_MEMBERSHIP_LEVEL_TRANSITION_RECORDS',
  SEARCH_MEMBERSHIP_LEVEL_TRANSITION_RECORDS_ENDED:
    'SEARCH_MEMBERSHIP_LEVEL_TRANSITION_RECORDS_ENDED',
  SEARCH_MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORDS:
    'SEARCH_MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORDS',
  SEARCH_MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORDS_ENDED:
    'SEARCH_MEMBERSHIP_LEVEL_MANUAL_ADJUSTMENT_RECORDS_ENDED',
  SEARCH_MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORDS:
    'SEARCH_MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORDS',
  SEARCH_MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORDS_ENDED:
    'SEARCH_MEMBERSHIP_LEVEL_NON_MANUAL_ADJUSTMENT_RECORDS_ENDED',
  DELETE_MEMBERSHIP_LEVELS: 'DELETE_MEMBERSHIP_LEVELS',
  DELETE_MEMBERSHIP_LEVELS_ENDED: 'DELETE_MEMBERSHIP_LEVELS_ENDED',
  DELETE_MEMBERSHIP_LEVEL_RULES: 'DELETE_MEMBERSHIP_LEVEL_RULES',
  DELETE_MEMBERSHIP_LEVEL_RULES_ENDED: 'DELETE_MEMBERSHIP_LEVEL_RULES_ENDED',
  CREATE_MEMBERSHIP_LEVEL: 'CREATE_MEMBERSHIP_LEVEL',
  CREATE_MEMBERSHIP_LEVEL_ENDED: 'CREATE_MEMBERSHIP_LEVEL_ENDED',
  CREATE_MEMBERSHIP_LEVEL_RULE: 'CREATE_MEMBERSHIP_LEVEL_RULE',
  CREATE_MEMBERSHIP_LEVEL_RULE_ENDED: 'CREATE_MEMBERSHIP_LEVEL_RULE_ENDED',
  UPDATE_MEMBERSHIP_LEVEL: 'UPDATE_MEMBERSHIP_LEVELS',
  UPDATE_MEMBERSHIP_LEVEL_ENDED: 'UPDATE_MEMBERSHIP_LEVEL_ENDED',
  UPDATE_MEMBERSHIP_LEVEL_RULE: 'UPDATE_MEMBERSHIP_LEVEL_RULE',
  UPDATE_MEMBERSHIP_LEVEL_RULE_ENDED: 'UPDATE_MEMBERSHIP_LEVEL_RULE_ENDED',
  GET_ENABLED_MEMBERSHIP_LEVELS: 'GET_ENABLED_MEMBERSHIP_LEVELS',
  GET_ENABLED_MEMBERSHIP_LEVELS_END: 'GET_ENABLED_MEMBERSHIP_LEVELS_END',
};
export default actions;
